import LzSAppBasics from '@lz-app/AppBasics';

export const lzFLocalStorageKey = (key: string) => LzSAppBasics.app_code + '_' + key;

export const lzFLocalStoragePut = (key: string, data: any): void => {
    const fullKey = lzFLocalStorageKey(key);
    /*if (fullKey.indexOf('oken') > 0) {
        console.log('LZPut', fullKey, data);
    }*/

    localStorage.setItem(
        fullKey,
        JSON.stringify({ type: typeof data, value: data })
    );
};

export const lzFLocalStorageGet = (key: string, defaultData?: any): any => {
    try {
        const fullKey = lzFLocalStorageKey(key);

        const data = localStorage.getItem(fullKey); // loaded as json
        /*if (fullKey.indexOf('oken') > 0) {
            console.log('LZGet', fullKey, data);
        }*/

        // If not found then send default data
        if (!data) {
            return defaultData;
        }

        // Else parse json
        const load = JSON.parse(data);

        // Return the saved value
        return load.value;
    } catch (e: any) {
        console.error('LocalStorage: ' + key, e.toString());
        return '';
    }
};

export const lzFLocalStorageRemove = (key: string): void => {
    const fullKey = lzFLocalStorageKey(key);

    localStorage.removeItem(fullKey);
};
